import { Image, NewShirt } from "../shirts/types";
import {
  deleteCall,
  postCall,
  getCall,
  putCall,
  patchCall,
  HeadersInterface,
  BodyParamsInterface,
  convertInterfaceToBodyParams,
  QueryParamsInterface,
} from "./api";

const BASE_URL = "v1/shirts";
const TOPS_URL = "v1/tops";
const SHOP_URL = "v1/shop/shirts";

export const getShirtDetails = async (shirtId: number) => {
  let url = BASE_URL + "/" + shirtId;
  let headers: HeadersInterface | undefined;

  let response = await getCall(url, headers, undefined);

  return response.data;
};

export const searchShirts = async (params: string) => {
  let url = BASE_URL;
  let headers: HeadersInterface | undefined;

  let response = await getCall(url, headers, params);

  return response.data;
};

export const searchShirtsPublic = async (params: string) => {
  let url = "v1/shirts-public";
  let headers: HeadersInterface | undefined;

  let response = await getCall(url, headers, params, true); // Skip logout on 401 for public endpoint

  return response.data;
};

export const searchShopShirts = async (params: string) => {
  let url = SHOP_URL;
  let headers: HeadersInterface | undefined;

  let response = await getCall(url, headers, params);

  return response.data;
};

export const getAllConditions = async () => {
  let url = BASE_URL + "/conditions";
  let headers: HeadersInterface | undefined;

  let response = await getCall(url, headers, undefined);

  return response.data;
};

export const newShirt = async (shirtInstance: NewShirt) => {
  let url = BASE_URL;
  let headers: HeadersInterface | undefined;

  let body: BodyParamsInterface = convertInterfaceToBodyParams(shirtInstance);
  let response = await postCall(url, headers, undefined, body);

  return response.data;
};

export const deleteShirt = async (shirtId: number) => {
  let url = BASE_URL + "/" + shirtId;
  let headers: HeadersInterface | undefined;

  let response = await deleteCall(url, headers);

  return response;
};

export const updateShirt = async (shirtId: number, shirtInstance: NewShirt) => {
  let url = BASE_URL + "/" + shirtId;
  let headers: HeadersInterface | undefined;

  let body: BodyParamsInterface = convertInterfaceToBodyParams(shirtInstance);
  let response = await patchCall(url, headers, undefined, body);

  return response.data;
};

export const updateProperty = async (
  shirtId: number,
  propertyId: number,
  extraData: any,
  prevPropertyId?: number
) => {
  if (prevPropertyId) {
    let url = BASE_URL + "/" + shirtId + "/property/" + prevPropertyId;
    let headers: HeadersInterface | undefined;

    await deleteCall(url, headers);
  }

  let url = BASE_URL + "/" + shirtId + "/property/" + propertyId;
  let headers: HeadersInterface | undefined;

  let body: BodyParamsInterface = convertInterfaceToBodyParams({
    extra_data: extraData,
  });
  let response = await putCall(url, headers, undefined, body);
  return response.data;
};

export const updateImages = async (shirtId: number, images: Array<Image>) => {
  let url = BASE_URL + "/" + shirtId + "/images";
  let headers: HeadersInterface | undefined;

  let body: BodyParamsInterface = convertInterfaceToBodyParams({
    images: images,
  });
  let response = await putCall(url, headers, undefined, body);

  return response.data;
};

export const updateCustomPrice = async (
  shirtId: number,
  customPrice: string
) => {
  let url = BASE_URL + "/" + shirtId + "/manual-price";
  let headers: HeadersInterface | undefined;

  let body: BodyParamsInterface = convertInterfaceToBodyParams({
    price: Number(customPrice),
    override: true,
  });
  let response = await putCall(url, headers, undefined, body);

  return response.data;
};

export const getTop10 = async (userId: number) => {
  let url = TOPS_URL + "/" + userId;
  let headers: HeadersInterface | undefined;
  let queryParams = "page=1&perPage=100";

  let response = await getCall(url, headers, queryParams);

  return response.data;
};

export const addItemTop10 = async (shirtId: number, position: number) => {
  let url = TOPS_URL + "/" + shirtId;
  let headers: HeadersInterface | undefined;

  let body: BodyParamsInterface = convertInterfaceToBodyParams({
    position: position,
  });
  let response = await putCall(url, headers, undefined, body);

  return response;
};

export const deleteItemTop10 = async (shirtId: number) => {
  let url = TOPS_URL + "/" + shirtId;
  let headers: HeadersInterface | undefined;

  let response = await deleteCall(url, headers);

  return response;
};
